export const GameGridSubcategoriesActionsDeviceTypesEnum = Object.freeze({
    ALL: 'all',
    DESKTOP_WEB: 'web',
    MOBILE_WEB: 'mobile',
});
